query DocumentPoolRecipients(
  $orderBy: [DocumentPoolRecipientsOrderBy!]
  $filter: DocumentPoolRecipientFilter
) {
  documentPoolRecipients(orderBy: $orderBy, filter: $filter) {
    nodes {
      id
      name
      description
      isDocumentTypeSelector
      extractionTypeId
      recipientDefaultDocumentTypes {
        id
        documentType
        extractionTypes {
          nodes {
            id
            extractionType
          }
        }
      }
      recipientPoolTotals {
        availableDocuments
        selectedDocuments
      }
    }
  }
}
